// MonthFilterContext.tsx
import React, { createContext, useContext, useState } from 'react'

interface MonthFilterContextType {
  month: number
  year: number
  distributorId: string | null

  setMonthYear: (month: number, year: number) => void
  prevMonth: () => void
  nextMonth: () => void
  resetToNow: () => void
  setDistributor: (id: string | null) => void // Nova função
}

const MonthFilterContext = createContext<MonthFilterContextType | undefined>(undefined)

export const MonthFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const now = new Date()
  const [month, setMonth] = useState<number>(now.getMonth())
  const [year, setYear] = useState<number>(now.getFullYear())
  const [distributorId, setDistributorId] = useState<string | null>(null) // Novo estado

  const setMonthYear = (m: number, y: number) => {
    setMonth(m)
    setYear(y)
  }

  const prevMonth = () => {
    if (month === 0) {
      setMonth(11)
      setYear((y) => y - 1)
    } else {
      setMonth((m) => m - 1)
    }
  }

  const nextMonth = () => {
    if (month === 11) {
      setMonth(0)
      setYear((y) => y + 1)
    } else {
      setMonth((m) => m + 1)
    }
  }

  const resetToNow = () => {
    const n = new Date()
    setMonth(n.getMonth())
    setYear(n.getFullYear())
  }

  const setDistributor = (id: string | null) => {
    setDistributorId(id)
  }

  return (
    <MonthFilterContext.Provider
      value={{
        month,
        year,
        distributorId,
        setMonthYear,
        prevMonth,
        nextMonth,
        resetToNow,
        setDistributor,
      }}
    >
      {children}
    </MonthFilterContext.Provider>
  )
}

export const useMonthFilter = (): MonthFilterContextType => {
  const ctx = useContext(MonthFilterContext)
  if (!ctx) throw new Error('useMonthFilter must be used within MonthFilterProvider')
  return ctx
}
